/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ExcludeType = {
  Type0: "type0",
  Type1: "type1",
  Type2: "type2",
} as const;
export type ExcludeType = ClosedEnum<typeof ExcludeType>;

export const GetApiV3MetricsTotalRewardableNodesCountFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsTotalRewardableNodesCountFormat = ClosedEnum<
  typeof GetApiV3MetricsTotalRewardableNodesCountFormat
>;

export type GetApiV3MetricsTotalRewardableNodesCountRequest = {
  excludeTypes?: Array<ExcludeType> | undefined;
  format?: GetApiV3MetricsTotalRewardableNodesCountFormat | undefined;
};

/** @internal */
export const ExcludeType$inboundSchema: z.ZodNativeEnum<typeof ExcludeType> = z
  .nativeEnum(ExcludeType);

/** @internal */
export const ExcludeType$outboundSchema: z.ZodNativeEnum<typeof ExcludeType> =
  ExcludeType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ExcludeType$ {
  /** @deprecated use `ExcludeType$inboundSchema` instead. */
  export const inboundSchema = ExcludeType$inboundSchema;
  /** @deprecated use `ExcludeType$outboundSchema` instead. */
  export const outboundSchema = ExcludeType$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsTotalRewardableNodesCountFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsTotalRewardableNodesCountFormat> = z
    .nativeEnum(GetApiV3MetricsTotalRewardableNodesCountFormat);

/** @internal */
export const GetApiV3MetricsTotalRewardableNodesCountFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsTotalRewardableNodesCountFormat> =
    GetApiV3MetricsTotalRewardableNodesCountFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalRewardableNodesCountFormat$ {
  /** @deprecated use `GetApiV3MetricsTotalRewardableNodesCountFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalRewardableNodesCountFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalRewardableNodesCountFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalRewardableNodesCountFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsTotalRewardableNodesCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalRewardableNodesCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    exclude_types: z.array(ExcludeType$inboundSchema).optional(),
    format: GetApiV3MetricsTotalRewardableNodesCountFormat$inboundSchema
      .default("json"),
  }).transform((v) => {
    return remap$(v, {
      "exclude_types": "excludeTypes",
    });
  });

/** @internal */
export type GetApiV3MetricsTotalRewardableNodesCountRequest$Outbound = {
  exclude_types?: Array<string> | undefined;
  format: string;
};

/** @internal */
export const GetApiV3MetricsTotalRewardableNodesCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalRewardableNodesCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsTotalRewardableNodesCountRequest
  > = z.object({
    excludeTypes: z.array(ExcludeType$outboundSchema).optional(),
    format: GetApiV3MetricsTotalRewardableNodesCountFormat$outboundSchema
      .default("json"),
  }).transform((v) => {
    return remap$(v, {
      excludeTypes: "exclude_types",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalRewardableNodesCountRequest$ {
  /** @deprecated use `GetApiV3MetricsTotalRewardableNodesCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalRewardableNodesCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalRewardableNodesCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalRewardableNodesCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalRewardableNodesCountRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsTotalRewardableNodesCountRequest$Outbound;
}

export function getApiV3MetricsTotalRewardableNodesCountRequestToJSON(
  getApiV3MetricsTotalRewardableNodesCountRequest:
    GetApiV3MetricsTotalRewardableNodesCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTotalRewardableNodesCountRequest$outboundSchema.parse(
      getApiV3MetricsTotalRewardableNodesCountRequest,
    ),
  );
}

export function getApiV3MetricsTotalRewardableNodesCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsTotalRewardableNodesCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTotalRewardableNodesCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsTotalRewardableNodesCountRequest' from JSON`,
  );
}
